<template>
  <div
    v-if="props.coach"
    class="i-selected-coach-details"
  >
    <div class="container">
      <div
        id="selected-coach-details-summary"
        class="summary"
      >
        <div class="grid-2col">
          <div
            v-if="!isMobileOrLarger || (isTabletOrLarger && !isDesktopOrLarger) || isMassiveOrLarger"
            class="left"
          >
            <div
              v-if="'percentMatch' in props.coach"
              class="badge"
            >
              <div class="inner">Top pick: {{ props.coach.percentMatch }}% Match</div>
            </div>
            <img
              class="image"
              :src="props.coach.profilePhotoUrl || ''"
            />

            <template v-if="!!props.coach.introVideoUrl">
              <div
                class="play-video"
                @click="data.lightBoxVideo = props.coach.introVideoUrl || ''"
              >
                <img
                  class="play"
                  :src="iconPlay"
                />
                <div class="time">{{ getVideoDuration(props.coach.introVideoUrl) }}</div>
              </div>
            </template>
          </div>

          <div class="right">
            <div class="tab-image-view">
              <div
                v-if="(isMobileOrLarger && !isTabletOrLarger) || (isDesktopOrLarger && !isMassiveOrLarger)"
                class="left"
              >
                <img
                  class="image"
                  :src="props.coach.profilePhotoUrl || ''"
                />

                <template v-if="!!props.coach.introVideoUrl">
                  <div
                    class="play-video"
                    @click="data.lightBoxVideo = props.coach.introVideoUrl || ''"
                  >
                    <img
                      class="play"
                      :src="iconPlay"
                    />
                    <div class="time">{{ getVideoDuration(props.coach.introVideoUrl) }}</div>
                  </div>
                </template>
              </div>
              <div>
                <div class="coach">{{ props.coach.fullName || "Your Coach" }} <img :src="iconCheckBlue" /></div>
                <div class="career-coach">Career Coach</div>
                <div class="rating">
                  <img :src="iconStars1" />
                  {{ props.coach.rating }} stars
                  <span
                    class="review-cta"
                    @click="setTabAndScroll(3)"
                    >(<u>{{ data.reviews?.length || numberOfReviews }} reviews</u>)</span
                  >
                </div>
              </div>
            </div>
            <div
              v-if="!isTabletOrLarger"
              class="ctas"
            >
              <iBaseButton
                v-if="!!props.coach.fullName && !!props.coach.calcomUsername"
                v-bind="BOOKING_BUTTON_STYLE"
                :text="
                  userStore.isCoachingPaiduser
                    ? `Book a New Session with ${coachFirstName}`
                    : `Check ${coachFirstName}'s Availability`
                "
                @clicked="$emit('openCalcomModal', true)"
              />
              <template v-if="userStore.isCoachingPaiduser">
                <iBaseButton
                  v-if="userStore.getCoachingStatus != CoachingStatus.ONCE"
                  v-bind="OTHER_BUTTON_STYLE"
                  text="Manage Subscription"
                  @clicked="openUrl(SUBSCRIPTION_LINK)"
                />
                <iBaseButton
                  v-if="!userStore.isReportUser"
                  v-bind="OTHER_BUTTON_STYLE"
                  text="Take a Career Test"
                  @clicked="clickOnTakeTest"
                />
              </template>
            </div>
            <div class="stats">
              <div class="stat">
                <img :src="iconClients" />
                <span>
                  <strong>{{ props.coach.clientsServed || 280 }} clients</strong> landed their dream careers by working
                  with {{ coachFirstName || "this coach" }}.
                </span>
              </div>
              <div class="stat">
                <img :src="iconBoost" />
                <span>
                  {{ coachFirstName || "this coach" }}’s clients achieved
                  <strong>{{ props.coach.salaryBoostPercent || 30 }}%</strong> in average salary boost.
                </span>
              </div>
              <div class="stat">
                <img :src="iconPhoneCall" />
                <span>
                  <strong>99%</strong> of {{ coachFirstName || "this coach" }}’s clients received a job interview within
                  3 months.
                </span>
              </div>
            </div>
            <div
              v-if="isTabletOrLarger"
              class="ctas"
            >
              <iBaseButton
                v-if="!!props.coach.fullName && !!props.coach.calcomUsername"
                v-bind="BOOKING_BUTTON_STYLE"
                :text="
                  userStore.isCoachingPaiduser
                    ? `Book a New Session with ${coachFirstName}`
                    : `Check ${coachFirstName}'s Availability`
                "
                @clicked="$emit('openCalcomModal', true)"
              />
              <template v-if="userStore.isCoachingPaiduser">
                <iBaseButton
                  v-if="userStore.getCoachingStatus != CoachingStatus.ONCE"
                  v-bind="OTHER_BUTTON_STYLE"
                  text="Manage Subscription"
                  @clicked="openUrl(SUBSCRIPTION_LINK)"
                />
                <iBaseButton
                  v-if="!userStore.isReportUser"
                  v-bind="OTHER_BUTTON_STYLE"
                  text="Take a Career Test"
                  @clicked="clickOnTakeTest"
                />
              </template>
            </div>
          </div>
        </div>
      </div>

      <div
        id="selected-coach-details-tabs"
        class="details"
      >
        <div
          class="tabs"
          :class="{ two: !props.isAssignedCoach || !assignedCoachMatchReason }"
        >
          <div
            v-if="props.isAssignedCoach && assignedCoachMatchReason"
            class="tab"
            :class="{ active: props.activeTab === 1 }"
            @click="$emit('setActiveTab', 1)"
          >
            Why {{ coachFirstName }}
          </div>
          <div
            class="tab"
            :class="{ active: props.activeTab === 2 }"
            @click="$emit('setActiveTab', 2)"
          >
            About
          </div>
          <div
            class="tab"
            :class="{ active: props.activeTab === 3 }"
            @click="$emit('setActiveTab', 3)"
          >
            Testimonials
          </div>
        </div>
        <div class="content">
          <div v-if="props.activeTab === 1 && assignedCoachMatchReason">
            <div class="title">Why are you matched with coach {{ coachFirstName }}</div>
            <div>{{ assignedCoachMatchReason }}</div>
          </div>
          <div
            v-if="props.activeTab === 2"
            class="bio"
          >
            <div class="professional">
              <div class="title">{{ coachFirstName }}'s Professional Biography</div>
              <iBaseExpandableParagraph
                :text="props.coach.biography || ''"
                text-size="unset"
                text-name="full biography"
                :collapsed-length="descriptionMaxlength"
              />
            </div>
            <!-- <div class="personal">
              <div class="title">{{ coachFirstName }}'s Personal Biography</div>
              <iBaseExpandableParagraph
                :text="assignedCoach?.biography || ''"
                text-size="unset"
                text-name="full biography"
                :collapsed-length="descriptionMaxlength"
              />
            </div> -->
          </div>
          <div
            v-if="props.activeTab === 3"
            class="reviews"
          >
            <Carousel
              :autoplay="30000"
              :items-to-scroll="1"
              :items-to-show="isMassiveOrLarger ? 2 : 1"
              class="reviews-carousel"
              pause-autoplay-on-hover
              wrap-around
              snap-align="start"
            >
              <Slide
                v-for="(review, index) in data.reviews?.length ? data.reviews : reviewData"
                :key="index"
              >
                <div class="review">
                  <div class="info">
                    <img
                      v-if="review.userImageUrl"
                      class="rev-image"
                      :src="review.userImageUrl"
                    />
                    <div
                      v-else
                      class="initials"
                    >
                      {{ getInitials(review.clientName) }}
                    </div>
                    <div class="user-info">
                      <strong>{{ review.clientName }}</strong>
                      <div class="location"><img :src="iconLocation" /> USA</div>
                    </div>
                  </div>
                  <div class="star-date">
                    <img
                      class="stars"
                      :src="iconStars"
                    />
                    <div class="date">
                      {{
                        new Date(review.date).toLocaleDateString("en-US", {
                          month: "short",
                          day: "numeric",
                          year: "numeric"
                        })
                      }}
                    </div>
                  </div>
                  <div class="body">
                    <div
                      class="progress"
                      v-html="review.title"
                    ></div>
                    <div class="comment">{{ review.body }}</div>
                  </div>
                </div>
              </Slide>
              <template #addons>
                <navigation>
                  <template #next>
                    <span>
                      <img
                        :src="iconArrowRightGray"
                        alt="next-icon"
                      />
                    </span>
                  </template>
                  <template #prev>
                    <span>
                      <img
                        :src="iconArrowLeftGray"
                        alt="prev-icon"
                      />
                    </span>
                  </template>
                </navigation>
              </template>
            </Carousel>
          </div>
          <div class="help">
            <div class="icon">?</div>
            <div class="wrapper">
              <div class="options">
                <div
                  v-for="info in infoData.filter((e: any) => e.show)"
                  :key="info.caption"
                  class="option"
                  @click="info.action()"
                >
                  {{ info.title ?? info.caption }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-if="data.lightBoxVideo">
      <iBaseLightBox @close="data.lightBoxVideo = ''">
        <video
          :src="data.lightBoxVideo"
          autoplay
          controls
          class="light-box-video"
          type="video/mp4"
        ></video>
      </iBaseLightBox>
    </template>

    <iBaseModal
      :visible="data.showInfoModal"
      :fully-customisable="true"
      :enable-bg-close="true"
      :max-width="isMobileOrLarger ? '600px' : '350px'"
      @click-on-close="data.showInfoModal = false"
    >
      <div class="info-modal">
        <div class="modal-top">
          <div class="caption">{{ infoData[data.activeInfoIndex].caption }}</div>
          <div v-html="infoData[data.activeInfoIndex].content"></div>
        </div>
        <div class="bottom">
          <iBaseButton
            v-bind="MODAL_BUTTON_STYLE"
            width="fit-content"
            text="Close"
            @clicked="data.showInfoModal = false"
          />
        </div>
      </div>
    </iBaseModal>

    <iBaseModal
      class="embed"
      :visible="props.showCalcomEmbedModal"
      :fully-customisable="true"
      max-width="100%"
      @click-on-close="$emit('openCalcomModal', false)"
    >
      <div class="confirmation-modal">
        <iCalcomScheduler
          :key="calcomEmbedLink"
          :on-booking-successful="goToSelectPlan"
          :embed-link="calcomEmbedLink"
          version="inline"
        />
      </div>
    </iBaseModal>
  </div>
</template>

<script setup lang="ts">
import { useCoachingStore } from "@/stores/coaching"
import { useUserStore } from "@/stores/user"
import { azureRadiance600, bluePurpleGradient, white } from "@/styles/colors"
import { breakpointLg, breakpointMd, breakpointSm, breakpointXl } from "@/styles/variables"
import { computed, onMounted, reactive, watch } from "vue"
import { useRouter } from "vue-router"
import { Carousel, Navigation, Slide } from "vue3-carousel"

import { getVideoDuration } from "@/composables/getVideoDuration"
import useIsScreenSize from "@/composables/useIsScreenSize"
import useRandomNumber from "@/composables/useRandomNumber"
import useRandomizedArray from "@/composables/randomizeArray"

import { GlobalFunctions } from "@/helpers/globalFunctions"
import { GlobalVariables } from "@/helpers/globalVariables"
import UrlService from "@/services/urlService"
import api from "@/services/apiClient"

import iBaseButton from "@/components/base/BaseButton.vue"
import iBaseExpandableParagraph from "@/components/base/BaseExpandableParagraph.vue"
import iBaseLightBox from "@/components/base/BaseLightBox.vue"
import iBaseModal from "@/components/base/BaseModal.vue"
import iCalcomScheduler from "@/components/global/CalcomScheduler.vue"

// ASSETS
import iconLocation from "@/assets/icons/icon-profile-location-black.svg"
import iconArrowLeftGray from "@/assets/icons/icon-arrow-left-gray.svg"
import iconArrowRightGray from "@/assets/icons/icon-arrow-right-gray.svg"
import iconStars1 from "@/assets/icons/icon-five-slashed-stars.svg"
import iconStars from "@/assets/icons/icon-five-stars.svg"
import iconPlay from "@/assets/icons/icon-play-blue-white.svg"
import iconCheckBlue from "@/assets/icons/icon-rounded-blue-tick.svg"
import iconBoost from "@/assets/icons/icon-rocket-thick.svg"
import iconClients from "@/assets/icons/icon-user.svg"
import iconPhoneCall from "@/assets/icons/icon-phone-call.svg"
import imageBrenden from "@/assets/images/Brenden-trustpilot.png"
import imageChristine from "@/assets/images/Christine-trustpilot.png"
import imageCory from "@/assets/images/Cory-trustpilot.png"
import imageDaniel from "@/assets/images/Daniel-trustpilot.png"
import imageDavid from "@/assets/images/David-trustpilot.png"
import imageJulie from "@/assets/images/Julie-trustpilot.png"
import imageTristan from "@/assets/images/Tristan-trustpilot.png"

// TYPES
import { CoachAssigned, CoachForSelection, CoachReviews } from "@/shared/types/Coach"
import CoachingStatus from "@/shared/enums/CoachingStatus"

// EMITS
const emit = defineEmits(["setActiveTab", "setNextCoachActive", "openCalcomModal"])

// STORES AND ROUTES
const coachingStore = useCoachingStore()
const userStore = useUserStore()
const router = useRouter()

// PROPS
const props = defineProps({
  coach: {
    type: Object as () => CoachAssigned | CoachForSelection | null,
    required: true
  },
  isAssignedCoach: {
    type: Boolean,
    default: false
  },
  activeTab: {
    type: Number as () => 1 | 2 | 3,
    required: true
  },
  showCalcomEmbedModal: {
    type: Boolean,
    required: true
  }
})

// COMPOSABLES
const isMobileOrLarger = useIsScreenSize(breakpointSm)
const isTabletOrLarger = useIsScreenSize(breakpointMd)
const isDesktopOrLarger = useIsScreenSize(breakpointLg)
const isMassiveOrLarger = useIsScreenSize(breakpointXl)

// CONSTANTS
const BOOKING_BUTTON_STYLE = {
  backgroundImage: bluePurpleGradient,
  borderRadius: "8px",
  fontWeight: "500",
  textColor: white,
  width: "100%",
  padding: "12px 24px",
  size: "medium"
}

const OTHER_BUTTON_STYLE = {
  backgroundColor: "transparent",
  borderRadius: "8px",
  fontWeight: "500",
  textColor: azureRadiance600,
  width: "100%",
  padding: "12px 24px",
  version: "outline"
}

const MODAL_BUTTON_STYLE = {
  size: "small",
  fontWeight: "500",
  width: "100%",
  backgroundColor: azureRadiance600,
  borderRadius: "12px",
  textColor: white
}

const SUBSCRIPTION_LINK = "https://billing.stripe.com/p/login/eVa4hK1JEcw43g4aEE"

// DATA
const data = reactive({
  lightBoxVideo: "",
  showInfoModal: false,
  activeInfoIndex: 0,
  reviews: [] as CoachReviews[]
})

// COMPUTED
const coachFirstName = computed(() => props.coach?.fullName?.split(" ")[0])

const numberOfReviews = computed(() => useRandomNumber(props.coach?.fullName || "Full Name", 17, 35))

const assignedCoachMatchReason = computed(() => {
  const coach = props.coach
  if (!coach || !("matchReason" in coach)) return null
  return (coach as CoachAssigned).matchReason?.replace(/\*/g, "")
}) // Remove asterisks that might be added by the backend

const calcomEmbedLink = computed(() => {
  const isUnpurchasedExecutivePotential = !userStore.isCoachingHasEngaged && userStore.isExecutiveCoachingPotential
  const slug = isUnpurchasedExecutivePotential ? "discovery-60" : "discovery-30"
  return UrlService.generateCalComEmbedLink(`${props.coach?.calcomUsername}/${slug}`)
})

const descriptionMaxlength = computed(() =>
  isMassiveOrLarger.value
    ? 4000
    : isDesktopOrLarger.value
      ? 1000
      : isTabletOrLarger.value
        ? 1200
        : isMobileOrLarger.value
          ? 700
          : 400
)

const reviewData = computed(() => {
  const coachFirstName = props.coach?.fullName?.split(" ")[0]
  return useRandomizedArray([
    {
      clientName: "Christine S.",
      date: "2025-12-11",
      userImageUrl: imageChristine,
      title: `Finding direction and <strong>confidence</strong> with ${coachFirstName}`,
      body: `I stumbled across Jobtest during my Google research while contemplating a career shift. After taking the career test, I signed up for biweekly sessions with ${coachFirstName}. Beyond just providing accountability, ${coachFirstName} guided me to online and local resources I wasn't aware of and gave me the confidence to pursue a career in interior design. ${coachFirstName} is incredibly kind and supportive, celebrating my progress each time we meet. I’ve gained so much direction and stability, and I hope my future job suits me as well as ${coachFirstName}'s does to them!`
    },
    {
      clientName: "Brenden C.",
      date: "2025-12-01",
      userImageUrl: imageBrenden,
      title: `Pursuing a <strong>career change</strong> with ${coachFirstName}.`,
      body: `I was looking for a career change, and Jobtest really helped me clarify my career interests better than any other test. The offer to speak with ${coachFirstName} was super helpful. ${coachFirstName} was extremely friendly and insightful, guiding me on the next steps I should take. I now feel more confident with a guided plan to achieve my goals.`
    },
    {
      clientName: "Julie B.",
      date: "2025-11-25",
      userImageUrl: imageJulie,
      title: `<strong>Transitioning to a new career</strong> with ${coachFirstName}.`,
      body: `I had the good fortune of meeting with ${coachFirstName}, who really understands what it's like to make a career transition. ${coachFirstName} asked great questions, offered valuable insights, and provided actionable next steps. As a former teacher like me, ${coachFirstName} brought both optimism and expertise to our sessions. I'm now feeling much more hopeful about my career journey.`
    },
    {
      clientName: "Tristan B.",
      date: "2025-11-18",
      userImageUrl: imageTristan,
      title: `<strong>Moving forward</strong> with ${coachFirstName}.`,
      body: `I was honestly apprehensive about trying this; it could very easily be a scam. But after taking the assessment, I got paired with ${coachFirstName}, who truly listened to me, and we made a great connection right away. ${coachFirstName} introduced me to many things, including positions and industries I had never even heard of. I’m quite excited to see what the future holds, and I think Jobtest is helping me move in the right direction.`
    },
    {
      clientName: "Daniel B.",
      date: "2025-10-16",
      userImageUrl: imageDaniel,
      title: `Exploring <strong>new career paths</strong> with ${coachFirstName}.`,
      body: `Today, ${coachFirstName} was incredibly thorough and positive, helping me navigate the results from jobtest.org and offering valuable insights into potential careers. ${coachFirstName}'s dedication made me feel truly valued, and our conversation felt like a discussion between good friends, backed by accurate test data. I’m grateful for the time and extra effort ${coachFirstName} put in to help me explore new perspectives and potential roles.`
    },
    {
      clientName: "Cory O.",
      date: "2025-09-07",
      userImageUrl: imageCory,
      title: `<strong>Rediscovering purpose</strong> with ${coachFirstName}`,
      body: `Jobtest uses a unique scoring mechanism that opened my eyes to careers I hadn't considered before. I chose the coaching option, and ${coachFirstName} helped me think deeply about careers, applications, resumes, and the job market in a whole new way. Thanks to ${coachFirstName} and Jobtest, I'm now on a journey to find work that inspires me, has a real impact, and aligns with who I am as a person. This has been a powerful experience in my mid-30s, realizing that monetary success alone isn't enough.`
    },
    {
      clientName: "David F.",
      date: "2025-09-24",
      userImageUrl: imageDavid,
      title: `From skepticism to <strong>success</strong> with ${coachFirstName}`,
      body: `I was skeptical at first, but ${coachFirstName} changed my mind almost immediately after our first conversation. I was just expecting some quick resume tips, but ${coachFirstName} ended up coaching me for a couple of months, meeting every other week. Ultimately, it's what you make of it, but I’d say ${coachFirstName} is one of the best coaches in the game.`
    }
  ])
})

const infoData = computed(() => {
  return [
    {
      caption: "How much is the coaching session?",
      show: !userStore.isCoachingPaiduser,
      action: () => showInfoModal(0),
      content:
        "Our coaching sessions are designed to be flexible and tailored to your needs. You can start with a single 30-minute discovery session and then opt for a more frequent schedule with weekly sessions. <strong>Once you've selected the time and date for your first session</strong>, you'll have the opportunity to customize your coaching plan to best suit your goals.<br/><br/>All of our coaches at jobtest.org offer their expertise at a consistent rate. Depending on the plan you choose, <strong>pricing ranges from $149.90 for a 30-minute discovery session to $349.90 for a weekly session plan</strong>."
    },
    {
      title: "I am not ready to make a decision yet.",
      caption: "Not ready to make a decision yet?",
      show: !userStore.isCoachingPaiduser,
      action: () => showInfoModal(1),
      content:
        "We completely understand that making a decision about coaching is a big step. It’s important to feel confident and informed before committing. Here are a few things that might help you:<br/><br/><strong>Discovery Session:</strong> Consider starting with a no-obligation 30-minute discovery session. This session is designed to give you a firsthand experience of what our coaching can offer, helping you decide if it’s the right fit for you.<br/><br/><strong>Flexible Plans:</strong>  Our coaching plans are flexible and customizable. Whether you're ready to dive in or just want to start with a single session, you can choose a plan that matches your comfort level.<br/><br/><strong>100% Money-Back Guarantee:</strong>  If you're still unsure, remember that we offer a 100% money-back guarantee. This means you can try out our coaching services risk-free. Please read our <a href='https://www.jobtest.org/refund-policy' target='_blank'>Refund Policy</a> for more details."
    },
    {
      caption: "I want to change my coach.",
      show: userStore.isCoachingPaiduser,
      action: () => openUrl("https://survey.zigpoll.com/2tVLrZ1upJBnDCLQ3/2worxsN49rTtX4Brd")
    },
    {
      caption: "Can I book a single session with my coach?",
      show: userStore.isCoachingPaiduser,
      action: () => showInfoModal(3),
      content: `Yes! You can book a 30-min on-demand session with your coach without needing to subscribe. Please choose a single session option in your checkout page after selecting your desired time and date from ${props.coach}'s calendar.`
    },
    {
      title: userStore.isCoachingPaiduser
        ? "My coach doesn't have any availability."
        : "I can’t find a coach with the right availability.",
      caption: userStore.isCoachingPaiduser
        ? "Your coach doesn't have any availability?"
        : "Can’t find a coach with the right availability?",
      show: true,
      action: () => showInfoModal(4),
      content:
        "We understand how important it is to find a coach who fits your schedule. Our top coaches are in high demand, but we’re committed to helping you find the right match. Here’s what you can do:<br/><br/><strong>Join the Waitlist:</strong> If your preferred coach isn’t available, you can <strong><a href='https://survey.zigpoll.com/2tVLrZ1upJBnDCLQ3/2wUgT342Yyt8GCi7d' target='_blank'>join their waitlist</a></strong>. We’ll notify you as soon as a spot opens up that fits your schedule.<br/><br/><strong>Personal Assistance:</strong> If you’re having trouble finding availability, our team is here to help. Please <strong><a href='https://survey.zigpoll.com/2tVLrZ1upJBnDCLQ3/2wUhqYcrMubg4Wmxw' target='_blank'>fill out this form</a></strong>, and a specialist will reach out to work with you personally to secure a session time that fits your schedule."
    }
  ]
})

// FUNCTIONS
const getInitials = (fullName: string) => {
  const name = fullName.trim()
  if (!name) return ""

  const nameArray = name.split(" ")
  const arrLength = nameArray.length

  const firstInitial = nameArray[0][0]
  const lastInitial = arrLength > 1 ? nameArray[arrLength - 1][0] : ""

  return `${firstInitial}${lastInitial}`.toUpperCase()
}
const setTabAndScroll = (tab: number) => {
  emit("setActiveTab", tab)
  GlobalFunctions.scrollInToElement("#selected-coach-details-tabs")
}
function clickOnTakeTest() {
  router.push({ name: GlobalVariables.urls.report.children.testRetake.routeName })
}

function openUrl(redirectUrl: string) {
  window.open(redirectUrl, "_blank")
}

const goToSelectPlan = (e: any) => {
  localStorage.removeItem("checklist-reminder-checked")
  router.push({
    name: userStore.isExecutiveCoachingPotential
      ? GlobalVariables.urls.coaching.children.choosePlan.routeName
      : GlobalVariables.urls.coaching.children.selectPlan.routeName,
    query: { date: e.detail.data.date }
  })
}

const showInfoModal = (index: number) => {
  data.activeInfoIndex = index
  data.showInfoModal = true
}
const fetchCoachReviews = async () => {
  if (props.coach?.id) {
    try {
      const response = await api.coach.getCoachReviews(props.coach.id, {
        orderBy: "date",
        direction: "desc",
        minRating: 4
      })
      data.reviews = response.reviews
    } catch {
      console.error(`Error fetching coach's reviews. Coach: ${props.coach.id}`)
    }
  }
}

// LIFECYCLE HOOKS
onMounted(async () => {
  if (!coachingStore.hasAssignedCoach) await coachingStore.loadAssignedCoach()
  await fetchCoachReviews()
})

// WATCHERS
watch(
  () => props.coach?.id,
  async () => {
    await fetchCoachReviews()
  }
)
</script>

<style lang="scss" scoped>
.i-selected-coach-details {
  .container {
    @include flex($direction: column, $justify: center, $align: stretch, $gap: 20px);

    margin: auto;
    width: 100%;

    .summary {
      background-color: $white;
      border-radius: 20px;
      padding: 15px;
      border: 1px solid $zumthor200;

      @media screen and (min-width: $breakpoint-md) {
        padding: 30px;
      }

      .grid-2col {
        @include flex($direction: column, $justify: start, $align: stretch, $gap: 15px);

        @media screen and (min-width: $breakpoint-sm) {
          @include flex($direction: row, $justify: start, $align: start, $gap: 32px);
        }

        @media screen and (min-width: $breakpoint-xl) {
          @include flex($direction: row, $justify: start, $align: start, $gap: 32px);
        }

        .left {
          width: 100%;
          align-self: center;
          position: relative;

          @include flex(column, start, center, $gap: 20px);

          @media screen and (min-width: $breakpoint-sm) {
            align-self: unset;
            flex: 0 0 150px;
          }

          @media screen and (min-width: $breakpoint-md) {
            flex: 0 0 300px;
          }

          @media screen and (min-width: $breakpoint-lg) {
            flex: 0 0 150px;
          }

          @media screen and (min-width: $breakpoint-xl) {
            align-self: unset;
            flex: 0 0 300px;
          }

          .image {
            width: 100%;
            height: auto;
            border-radius: 8px;
          }

          .badge {
            @include border-radius-xxl;
            @include text-xs;

            text-transform: uppercase;
            width: fit-content;
            position: absolute;
            top: 5px;
            right: 5px;
            background-image: $blue-purple-gradient;
            font-weight: 600;

            @media screen and (min-width: $breakpoint-md) {
              font-weight: 700;
            }

            .inner {
              @include border-radius-xxl;

              padding: 4px 8px;
              background-color: #ffffffda;
              mix-blend-mode: screen;
            }
          }

          .play-video {
            @include border-radius-xxl;
            @include flex(row, start, center, $gap: 8px);

            position: absolute;
            cursor: pointer;
            left: 8px;
            bottom: 8px;
            background-color: rgb(159 159 159 / 50%);
            padding-right: 10px;

            .play {
              width: 32px;
              height: 32px;
            }

            .time {
              @include text-sm;

              color: $white;
              font-weight: 500;
              padding: 6px 0;
            }
          }
        }

        .right {
          @include flex(column, start, stretch);

          @media screen and (min-width: $breakpoint-xl) {
            @include flex(column, start, start);
          }

          .tab-image-view {
            @include flex(row, start, center, $gap: 20px);
          }

          .coach {
            @include text-lg;
            @include flex(row, space-between, center, $gap: 5px);

            font-weight: 700;
            color: $black950;

            @media screen and (min-width: $breakpoint-sm) {
              @include display-md;
            }

            @media screen and (min-width: $breakpoint-md) {
              @include flex(row, start, center, $gap: 10px);
            }
          }

          .career-coach {
            @include text-md;

            font-weight: 400;
            margin-bottom: 3px;
            color: $black700;
          }

          .rating {
            @include text-sm;

            font-weight: 500;
            color: $bilbao500;

            img {
              vertical-align: text-bottom;
              width: 95px;
            }

            .review-cta {
              cursor: pointer;
            }
          }

          .stats {
            margin-top: 20px;

            @include flex(column, center, start, $gap: 5px);

            .stat {
              @include flex(row, start, center, $gap: 10px);

              img {
                width: 18px;
              }
            }
          }

          .ctas {
            @include flex(column, start, stretch, $gap: 10px);

            margin-top: 20px;
          }
        }
      }
    }

    .details {
      @include flex($direction: column, $justify: start, $align: stretch, $gap: 15px);

      border: 1px solid $zumthor200;
      background-color: $white;
      border-radius: 20px;
      padding: 15px;

      @media screen and (min-width: $breakpoint-md) {
        padding: 30px;
      }

      .tabs {
        @include flex($direction: row, $justify: start, $align: stretch);

        overflow: scroll;
        -ms-overflow-style: none;
        scrollbar-width: none;

        &::-webkit-scrollbar {
          display: none;
        }

        .tab {
          @include flex(column, center, center);
          @include text-sm;

          width: 100%;
          text-align: center;
          border-bottom: 1px solid $zumthor100;
          color: $comet500;
          font-weight: 600;
          text-wrap-mode: nowrap;
          padding: 12px 10px;
          cursor: pointer;

          @media screen and (min-width: $breakpoint-md) {
            @include text-md;

            padding: 12px 10px;
            width: calc(100% / 3);
          }

          @media screen and (min-width: $breakpoint-lg) {
            text-wrap-mode: unset;
          }

          &:hover {
            background-color: $astronaut50;
          }

          &.active {
            border-bottom: 2px solid $astronaut600;
            background-color: $astronaut50;
            color: $astronaut600;
          }
        }

        &.two {
          .tab {
            @media screen and (min-width: $breakpoint-md) {
              width: calc(100% / 2);
            }
          }
        }
      }

      .content {
        .title {
          @include text-md;

          font-weight: 600;
        }

        .reviews {
          margin-bottom: 30px;

          .reviews-carousel {
            width: 100%;

            .review {
              @include flex($direction: column, $justify: start, $align: stretch, $gap: 15px);
              @include text-sm;

              padding: 15px;
              width: 100%;
              height: 100%;
              margin: 0 8px;
              text-align: left;
              border: 1px solid $zumthor100;
              border-radius: 20px;

              @media screen and (min-width: $breakpoint-sm) {
                @include text-md;

                padding: 22px 25px;
              }

              .info {
                @include flex(row, start, center, $gap: 10px);

                font-weight: 400;

                .rev-image {
                  @include border-radius-rounded;

                  width: 35px;
                  height: 35px;
                  object-fit: cover;

                  @media screen and (min-width: $breakpoint-sm) {
                    width: 40px;
                    height: 40px;
                  }
                }

                .initials {
                  font-weight: 700;
                  color: $pickle-bluewood900;
                  background-color: $brand-opacity100;
                  width: 35px;
                  height: 35px;

                  @include flex(row, center, center);
                  @include border-radius-rounded;

                  @media screen and (min-width: $breakpoint-sm) {
                    width: 40px;
                    height: 40px;
                  }
                }

                .user-info {
                  @include flex(column, center, start);

                  .location {
                    @include flex(row, start, center, $gap: 5px);

                    img {
                      width: 20px;
                      height: 20px;
                    }
                  }
                }
              }

              .star-date {
                @include flex(row, space-between, center, $gap: 10px);

                .stars {
                  height: 18px;
                }
              }

              .body {
                @include flex(column, start, start, $gap: 5px);

                .progress {
                  font-weight: 600;
                }

                .comment {
                  font-weight: 400;
                }
              }
            }
          }
        }

        .help {
          @include flex(row, end, center);

          position: relative;

          .icon {
            @include text-lg;
            @include border-radius-rounded;
            @include flex(column, center, center);

            width: 30px;
            height: 30px;
            background-color: $black950;
            color: $white;
            font-weight: 700;

            @media screen and (min-width: $breakpoint-md) {
              @include display-xs;

              width: 40px;
              height: 40px;
            }
          }

          .wrapper {
            display: none;
            position: absolute;
            bottom: -30%;

            @media screen and (min-width: $breakpoint-md) {
              bottom: 10%;
            }

            &:hover {
              display: block;
            }

            .options {
              @include border-radius-md;
              @include flex(column, start, stretch);

              border: 1px solid $zumthor100;
              box-shadow: 0 4px 16px 0 $black50;
              background-color: $white;
              padding: 10px 0;
              margin-bottom: 50px;

              .option {
                padding: 8px 20px;
                cursor: pointer;

                &:hover {
                  background-color: $black50;
                }
              }
            }
          }

          .icon:hover + .wrapper {
            display: block;
          }
        }
      }
    }
  }

  .confirmation-modal {
    margin: 10px;

    @media screen and (min-width: $breakpoint-md) {
      margin: 25px;
    }
  }

  .light-box-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    max-width: 840px;
    border-radius: 4px;
    overflow: hidden;
  }

  .info-modal {
    .modal-top {
      @include flex($direction: column, $justify: start, $align: center, $gap: 17px);

      margin: 25px;

      @include text-md;

      @media screen and (min-width: $breakpoint-md) {
        margin: 35px;

        @include text-lg;
      }

      .caption {
        font-weight: 700;

        @include display-xs;

        text-align: center;

        @media screen and (min-width: $breakpoint-md) {
          @include display-sm;
        }
      }
    }

    .bottom {
      @include flex($direction: row, $justify: center, $align: center, $gap: 0);

      background-color: $black50;
      padding: 12px 25px;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
    }
  }
}
</style>

<style lang="scss">
.i-selected-coach-details {
  /* stylelint-disable */
  .carousel__next,
  .carousel__prev {
    @include border-radius-rounded;

    top: calc(100% + 24px);
    border: 1px solid $zumthor100;
    padding: 0 2px 4px 2px;

    @media screen and (min-width: $breakpoint-md) {
      top: calc(100% + 30px);
    }
  }
  .carousel__next {
    right: 20%;

    @media screen and (min-width: $breakpoint-md) {
      right: 40%;
    }
  }
  .carousel__prev {
    left: 20%;

    @media screen and (min-width: $breakpoint-md) {
      left: 40%;
    }
  }
  /* stylelint-enable */
}
</style>
